import { render, staticRenderFns } from "./CompareWidthSelector.vue?vue&type=template&id=51935947"
import script from "./CompareWidthSelector.vue?vue&type=script&lang=js"
export * from "./CompareWidthSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports